import {
  Component, inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { LucideAngularModule, LucideIconData, CircleCheck, CircleX, Info, X } from 'lucide-angular';
import { ToastService, Toast } from '../../../core/services/toast.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-toast-host',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './toast-host.component.html',
})
export class ToastHostComponent {
  readonly toastService = inject(ToastService);

  protected readonly XIcon = X;

  toastClass(toast: Toast): string {
    const base = 'shadow-lg text-sm';
    switch (toast.type) {
      case 'success': return `${base} bg-[#0d1f15] border-[rgba(0,255,136,0.3)] text-[var(--nexus-green)]`;
      case 'error':   return `${base} bg-[#1f0d13] border-[rgba(255,51,102,0.3)] text-[var(--nexus-red)]`;
      default:        return `${base} bg-[var(--nexus-panel)] border-[var(--nexus-border)] text-[var(--nexus-text)]`;
    }
  }

  toastIcon(toast: Toast): LucideIconData {
    switch (toast.type) {
      case 'success': return CircleCheck;
      case 'error':   return CircleX;
      default:        return Info;
    }
  }
}
